import React from 'react';
import Text from '../../molecules/Text';

import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';

const DemoText = () => {
  return (
    <Box>
      <h2>Texts</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>H1 ('h1')</p>
        <Spacer />
        <Text type="h1" darkness="100" color="black">
          Lorem Ipsum is simply dummy text
        </Text>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>H2 ('h2')</p>
        <Spacer />
        <Text color="primary" type="h2">
          Lorem Ipsum is simply dummy text
        </Text>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>H3 ('h3')</p>
        <Spacer />
        <Text type="h3" color="neutral">
          Lorem Ipsum is simply dummy text
        </Text>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>H4 ('h4')</p>
        <Spacer />
        <Text type="h4">Lorem Ipsum is simply dummy text</Text>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>Body ('body')</p>
        <Spacer />
        <Text type="body">Lorem Ipsum is simply dummy text</Text>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>Card Body ('card-body')</p>
        <Spacer />
        <Text type="card-body">
          {'Lorem Ipsum <b>is </b><strong>simply dummy text</strong>'}
        </Text>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>H4 + Custom Weight + Strong Weight</p>
        <Spacer />
        <Text type="h4" weight="600" strongWeight="800">
          {'Lorem <b>Ipsum</b>'}
        </Text>
      </Flex>

      <Divider m={2} />
      <Flex align={'center'}>
        <p>H4 + Color + Darkness + Size + Mobile Size</p>
        <Spacer />
        <Text
          type="h4"
          color="primary"
          darkness="600"
          size="4xl"
          mobilesize="2xl"
        >
          Lorem Ipsum
        </Text>
      </Flex>
    </Box>
  );
};

export default DemoText;
